export { startProfiling, stopProfiling } from "react-native-release-profiler";
